// extracted by mini-css-extract-plugin
module.exports = {"dataGrid":"DataGrid_dataGrid_fDfgf"};